import React, { useEffect } from 'react'
import { bool, string, object, func, shape } from 'prop-types'
import FieldTemplate from '@/component/Primitive/FieldTemplate'
import TextControl from '@/component/Primitive/TextControl'
import Grid from '@/component/Primitive/Grid'
import ButtonStandard from '@/component/Primitive/ButtonStandard'
import Type from '@/component/Primitive/Type'
import ReCAPTCHA from 'react-google-recaptcha'
import styles from './Form.module.scss'

const widthMap = { full: 1, half: 1 / 2, quarter: 1 / 4 }

export const Form = ({
  successMessage,
  errorMessage,
  handleOnSubmit,
  handleOnChange,
  setValues,
  setErrors,
  data,
  errors = {},
  pageData,
  formBuilder,
  ...other
}) => {
  const recaptchaRef = React.createRef()
  const onReCAPTCHAChange = (code) => {
    setValues({ captcha: code })
  }
  const onSubmit = (e) => {
    e.preventDefault()
    const recaptchaValue = recaptchaRef.current.getValue()
    if (recaptchaValue) {
      return handleOnSubmit()
    }
    setErrors({ captcha: 'Please complete reCaptcha' })
  }

  useEffect(
    () => {
      setValues({ form: formBuilder._id })
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    // <ContactConfirmation
    //   message={{
    //     header: "Thank you",
    //     paragraph: thankyouMessage
    //   }}
    // />
    <form onSubmit={onSubmit}>
      <Grid gutter="large">
        {formBuilder?.questions?.map((q) => (
          <Grid.Item
            trailingGap="default"
            key={q.question}
            width={{ t: widthMap[q.width], m: 1 }}
          >
            <FieldTemplate label={q.question} required={q.required}>
              <TextControl
                name={q.question}
                onChange={handleOnChange}
                error={errors[q.question]}
                value={data[q.question]}
              />
            </FieldTemplate>
          </Grid.Item>
        ))}
        <div className={styles.Captcha}>
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6Ldot24dAAAAAOtGyb7-e6uenTEM91w4Mxw4WNnf"
            onChange={onReCAPTCHAChange}
          />
          {errors.captcha && (
            <Type as="h6" size="heading6" color="red">
              {errors.captcha}
            </Type>
          )}
        </div>
        <Grid.Item trailingGap="default" width={{ m: 1 }}>
          <ButtonStandard type="submit" name="submit" size="default" primary>
            Submit Message
          </ButtonStandard>
        </Grid.Item>
      </Grid>
    </form>
  )
}

// iterate all questions

Form.propTypes = {
  successMessage: string,
  errorMessage: string,
  errors: object,
  handleOnChange: func,
  handleOnSubmit: func,
  setValues: func,
  setErrors: func,
  data: object,
  waiting: bool,
  pageData: object,
  formBuilder: shape({
    questions: shape({ question: string, width: string })
  })
}
